import { useState } from "react";
import { fetchApi, getUserCookie, User } from "./data";
import { config } from "process";

export const AboutPanel = () => {
  const userCookie = getUserCookie();
  // console.log("userCookie", userCookie);
  let showInit = "";
  let nameInit = "";
  if (userCookie) {
    showInit = "show-logout" + (userCookie.admin === "1" ? " show-admin" : "");
    nameInit = userCookie.email;
  }

  const [show, setShow] = useState<string>(showInit);
  const [isLogin, setIsLogin] = useState<boolean>(!!userCookie);
  const [admin, setAdmin] = useState<string>(userCookie?.admin || "");
  const [users, setUsers] = useState<User[]>([]);

  const doSendCode = async () => {
    // console.log("doSendCode");
    const emailDom = document.querySelector(".uname") as HTMLInputElement;
    const email = emailDom.value;
    if (!email) {
      alert("Please enter email");
      return;
    }
    const res = await fetchApi("/api/send-code", {
      email,
    });
    // console.log(res);
    // if (res.json.status === "success") {
    alert(res.json && res.json.message);
    // } else {
    //   alert(res.json.message);
    // }
  };
  const doLogin = async () => {
    // console.log("doLogin");
    const emailDom = document.querySelector(".uname") as HTMLInputElement;
    const email = emailDom.value;
    const codeDom = document.querySelector(".ucode") as HTMLInputElement;
    const code = codeDom.value;
    if (!email || !code) {
      alert("Please enter email and code");
      return;
    }
    const res = await fetchApi("/api/verify-code", {
      email,
      code,
    });
    // console.log(res);
    if (res.json && res.json.status === "success") {
      setShow(
        "show-logout" + (res.json.user.admin === "1" ? " show-admin" : ""),
      );
      setIsLogin(true);
      setAdmin(res.json.user.admin);
    } else {
      alert(res.json && res.json.message);
    }
  };
  const doLogout = () => {
    document.cookie =
      "userData=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    setShow("");
    setIsLogin(false);
    setAdmin("");
  };
  const doRefreshUsers = async () => {
    const res = await fetchApi("/api/users");
    // console.log(res);
    if (res.json && res.json.status === "success") {
      setUsers(res.json.users);
    } else {
      alert(res.json && res.json.message);
    }
  };
  const doBlockUser = async (email: string, block: string) => {
    const res = await fetchApi("/api/update-user", {
      email,
      block,
    });
    // console.log(res);
    // if (res.json.status === "success") {
    alert(res.json && res.json.message);
    // } else {
    //   alert(res.json.message);
    // }
    doRefreshUsers();
  };
  const doAdmin = () => {
    setShow("show admin-part");
    doRefreshUsers();
    doReadEnv();
  };
  const doReadEnv = async () => {
    const envDom = document.querySelector(".uenv") as HTMLInputElement;
    const res = await fetchApi("/api/read-env");
    // console.log(res);
    if (res.json && res.json.status === "success") {
      envDom.value = res.json.envText;
    } else {
      alert(res.json && res.json.message);
    }
  };
  const doUpdateEnv = async () => {
    if (
      !window.confirm(
        "Are you sure to update env, it may cause unexpected behavior?",
      )
    ) {
      return;
    }
    const envDom = document.querySelector(".uenv") as HTMLInputElement;
    const res = await fetchApi("/api/update-env", {
      envText: envDom.value,
    });
    alert(res.json && res.json.message);
    doReadEnv();
  };
  const onAboutClick = () => {
    // setShow("show about-part");
    window.open("/about.html", "_blank");
  };
  return (
    <div className={"about-panel " + show}>
      {/* {!isLogin && (
        <div className="login-row">
          <div
            className="login-link"
            onClick={() => setShow("show login-part")}
          >
            Login
          </div>
        </div>
      )}

      {isLogin && (
        <div className="logout-row">
          Hi, {nameInit}
          <div className="logout-link" onClick={doLogout}>
            Logout
          </div>
          {admin === "1" && <div onClick={doAdmin}>Admin</div>}
        </div>
      )} */}

      <div className="about-link" onClick={onAboutClick}>
        Tutorial
      </div>
      <div
        className="details"
        style={{
          height: "100%",
          overflowY: "auto",
          backgroundColor: "#fefefe",
        }}
      >
        <div className="close-link" onClick={() => setShow("")}>
          X
        </div>
        <div className="detail-box login-box" style={{ marginBottom: "60px" }}>
          <h1>Login</h1>
          <div>
            <div className="text-field w100p">
              <input
                className="text-base w100p uname"
                type="text"
                required
                placeholder=" "
              />
              <span>Email *</span>
            </div>

            <button
              className="button-base"
              style={{ width: "160px", height: "20px" }}
              onClick={doSendCode}
            >
              Send Verification Code
            </button>
            <div className="text-field w100p">
              <input
                className="text-base w100p ucode"
                type="text"
                required
                placeholder=" "
              />
              <span>Verification Code *</span>
            </div>
            <button
              className="button-base"
              style={{ width: "100px" }}
              onClick={doLogin}
            >
              Login
            </button>
          </div>
        </div>
        <div className="detail-box admin-box" style={{ marginBottom: "60px" }}>
          <div style={{ paddingRight: "10px" }}>
            <div style={{ display: "flex" }}>
              <h3>Configuration Env:</h3>
              <button
                style={{ alignSelf: "end", cursor: "pointer" }}
                className="logout-link"
                onClick={doUpdateEnv}
              >
                Update
              </button>
            </div>
            <textarea
              className="text-base w100p uenv"
              style={{ width: "100%", height: "100px" }}
            />
          </div>
          <div>
            <div style={{ display: "flex" }}>
              <h3>Users:</h3>
              <button
                style={{ alignSelf: "end", cursor: "pointer" }}
                className="logout-link"
                onClick={doRefreshUsers}
              >
                Refresh
              </button>
            </div>
            {users.map((user) => (
              <div key={user.email} style={{ display: "flex" }}>
                <div>{user.email}</div>
                <div style={{ padding: "0 4px" }}>
                  {user.block === "1" ? "Blocked" : "Active"}
                </div>
                <button
                  style={{ cursor: "pointer" }}
                  className="logout-link"
                  onClick={() =>
                    doBlockUser(user.email, user.block === "1" ? "0" : "1")
                  }
                >
                  {user.block === "1" ? "Unblock" : "Block"}
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="detail-box about-box" style={{ marginBottom: "60px" }}>
          <h1>Draft</h1>
        </div>
      </div>
    </div>
  );
};
